export default __webpack_public_path__ + "files/9c0098c69ec2be5a0ca05c2643a2475d.png";